/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "../views/Index.js";

import User from "../containers/user/user";
import UserCreate from "../containers/user/userCreate";
import UserDetail from "../containers/user/userDetail";
import UserEdit from "../containers/user/userEdit";
import Bank from "../containers/bank/bank";
import BankDetail from "../containers/bank/bankDetail";
import BankEdit from "../containers/bank/bankEdit";
import Corporate from "../containers/corporate/corporate";
import CorporateCreate from "../containers/corporate/corporateCreate";
import CorporateDetail from "../containers/corporate/corporateDetail";
import CorporateEdit from "../containers/corporate/corporateEdit";
import Campaign from "../containers/campaign/campaign";
import CampaignCreate from "../containers/campaign/campaignCreate";
import CampaignDetail from "../containers/campaign/campaignDetail";
import CampaignEdit from "../containers/campaign/campaignEdit";

var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin",
    linkType:"main"
  },
  {
    path: "/user",
    name: "User Management",
    icon: "ni ni-single-02 text-yellow",
    component: User,
    layout: "/admin",
    linkType:"main"
  },
  {
    path: "/user/create",
    name: "Create User",
    icon: "ni ni-tv-2 text-primary",
    component: UserCreate,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/user/:id",
    name: "Get User",
    icon: "ni ni-tv-2 text-primary",
    component: UserDetail,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/user/edit/:id",
    name: "Edit User",
    icon: "ni ni-tv-2 text-primary",
    component: UserEdit,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/bank",
    name: "Banks",
    icon: "ni ni-building text-red",
    component: Bank,
    layout: "/admin",
    linkType:"main"
  },
  {
    path: "/bank/:id",
    name: "Get Bank",
    icon: "ni ni-building text-red",
    component: BankDetail,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/bank/edit/:id",
    name: "Edit Bank",
    icon: "ni ni-building text-red",
    component: BankEdit,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/corporate",
    name: "Corporate Management",
    icon: "ni ni-briefcase-24 text-blue",
    component: Corporate,
    layout: "/admin",
    linkType:"main"
  },
  {
    path: "/corporate/create",
    name: "Corporate Create",
    icon: "ni ni-building text-red",
    component: CorporateCreate,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/corporate/:id",
    name: "Corporate Detail",
    icon: "ni ni-building text-red",
    component: CorporateDetail,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/corporate/edit/:id",
    name: "Corporate Edit",
    icon: "ni ni-building text-red",
    component: CorporateEdit,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/campaign",
    name: "Campaigns",
    icon: "ni ni-collection text-green",
    component: Campaign,
    layout: "/admin",
    linkType:"main"
  },
  {
    path: "/campaign/create",
    name: "Create Campaigns",
    icon: "ni ni-building text-red",
    component: CampaignCreate,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/campaign/:id",
    name: "Get Campaign",
    icon: "ni ni-building text-red",
    component: CampaignDetail,
    layout: "/admin",
    linkType:"sub"
  },
  {
    path: "/campaign/edit/:id",
    name: "Edit Campaigns",
    icon: "ni ni-building text-red",
    component: CampaignEdit,
    layout: "/admin",
    linkType:"sub"
  },
];
export default routes;
